import { AxiosRequestConfig } from 'axios'
import merge from 'lodash/merge'

export interface Config {
  orrm: {
    jsonapi: AxiosRequestConfig;
    restapi: AxiosRequestConfig;
    siteURL: string;
  };
}

export interface WindowExt {
  config: Config;
}

const config = merge({
  orrm: {
    jsonapi: {
      baseURL: process.env.VUE_APP_ORRM_JSONAPI_BASE_URL ? process.env.VUE_APP_ORRM_JSONAPI_BASE_URL : '/jsonapi'
    },
    restapi: {
      baseURL: process.env.VUE_APP_ORRM_RESTAPI_BASE_URL ? process.env.VUE_APP_ORRM_RESTAPI_BASE_URL : '/orrm'
    },
    siteURL: process.env.VUE_APP_ORRM_BASE_URL ? process.env.VUE_APP_ORRM_BASE_URL : '/'
  }
}, (window as (Window & typeof globalThis & WindowExt)).config)

export default config
